const MissionSection = () => {
  const credentials = [
    {
      icon: 'ri-map-pin-line',
      label: 'Kentucky Establishment',
      value: 'Established in Kentucky',
    },
    {
      icon: 'ri-stethoscope-line',
      label: 'Physician-Led',
      value: 'Clinical expertise at the core',
    },
    {
      icon: 'ri-shield-check-line',
      label: 'Vendor-Neutral',
      value: 'Unbiased technology advisory',
    },
  ];

  return (
    <section className="py-24 bg-gray-bg">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <h2 className="font-serif text-4xl font-bold text-navy-primary mb-12 text-center">
            What We Stand For
          </h2>

          <div className="bg-white rounded-3xl p-12 shadow-xl mb-12">
            <h3 className="text-2xl font-bold text-navy-primary mb-6">
              Our Commitment
            </h3>
            <p className="text-base text-charcoal leading-relaxed mb-6">
              IRS Ventures delivers executive-level consulting that integrates
              practice management and operational optimization, administrative
              workflow redesign, digital transformation and IT integration, and
              comprehensive marketing strategy.
            </p>
            <p className="text-base text-charcoal leading-relaxed">
              We specialize in CRM platforms for patient inquiries and
              follow-ups, content management systems for scaling web content,
              clinical systems optimization including EHR and practice
              management platforms, patient engagement platforms, teleconsultation
              integration, revenue cycle optimization, SEO strategy, website
              performance optimization, workflow automation, and analytics
              dashboards for performance visibility.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {credentials.map((credential, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl p-8 text-center shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer"
              >
                <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
                  <i
                    className={`${credential.icon} text-5xl text-gold`}
                  ></i>
                </div>
                <p className="text-xs uppercase tracking-widest text-gold mb-2 font-semibold">
                  {credential.label}
                </p>
                <p className="text-sm text-navy-primary font-medium">
                  {credential.value}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default MissionSection;